import StepConfirmMeter from './StepConfirmMeter';
import { useTranslation } from 'react-i18next';
export const STEP_ASK_CONSENT_METER_CONFIRM_ID = 'step-ask-consent-meter-confirm';
export default function StepAskConsentMeterConfirm() {
  const { t } = useTranslation();

  return (
    <StepConfirmMeter
      message={t('step.ask.consent.meter.confirm.message')}
      description={t('step.ask.consent.meter.confirm.description')}
      actionLabel={t('step.ask.consent.meter.confirm.btn.label')}
    ></StepConfirmMeter>
  );
}
